import React from "react";
import { Button } from "../../../../ui/components/Button";
import { CashBankTransactionStatus } from "../../domain";
import { CASH_BANK_STATUS_OPTIONS } from "../utils/cashBankStatus";

interface CashBankStatusFilterPillsProps {
  value: CashBankTransactionStatus;
  onChange: (value: CashBankTransactionStatus) => void;
}

export const CashBankStatusFilterPills: React.FC<
  CashBankStatusFilterPillsProps
> = ({ value, onChange }) => (
  <div className="flex flex-wrap items-center gap-2">
    {CASH_BANK_STATUS_OPTIONS.map((option) => (
      <Button
        key={option.value}
        size="small"
        variant={value === option.value ? "brand-primary" : "neutral-secondary"}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </Button>
    ))}
  </div>
);
